import { $$ } from '../lib/domUtils';

// Disable a form's submit buttons once it has been submitted, so a double
// click can't post it twice.
const forms = $$('.js-single-submit');

forms.forEach((form) => {
  const buttons = $$('[type="submit"]', form);

  form.addEventListener('submit', () => {
    buttons.forEach((button) => {
      // eslint-disable-next-line no-param-reassign
      button.disabled = true;
    });
  });

  // Re-enable them if the page is restored from the back/forward cache.
  window.addEventListener('pageshow', () => {
    buttons.forEach((button) => {
      // eslint-disable-next-line no-param-reassign
      button.disabled = false;
    });
  });
});
